module.exports = __webpack_public_path__ + "8fd7c8eb0c52a2005808cc97c61d045f.png";